import { get as GET, put as PUT, post as POST, delete as DELETE } from 'axios'
import { baseURL } from 'utils/io'

const SET_EXTERNAL_APIKEY = 'SET_EXTERNAL_APIKEY'
const GET_EXTERNAL_APIKEY = 'GET_EXTERNAL_APIKEY'
const UPDATE_EXTERNAL_APIKEY = 'UPDATE_EXTERNAL_APIKEY'
const DELETE_EXTERNAL_APIKEY = 'DELETE_EXTERNAL_APIKEY'
const INVALIDATE_EXTERNAL_APIKEY = 'INVALIDATE_EXTERNAL_APIKEY'

const INITIAL_STATE = {}

const generateRequestFor = (path, methodFunc, payload) => async () => {
  try {
    return await methodFunc(`${baseURL}/apps/${path}`, payload)
  } catch (err) {
    if (err.response?.data?.message) {
      throw { error: err.response.data.message }
    }

    throw err
  }
}

// Reducers
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${SET_EXTERNAL_APIKEY}_FULFILLED`:
    case `${UPDATE_EXTERNAL_APIKEY}_FULFILLED`: {
      const { appId } = action.meta

      const apiKey = {
        ...action.payload.data,
        isValid: true,
      }

      if (state.thirdPartyApiKeys && state.thirdPartyApiKeys[appId]) {
        return {
          ...state,
          [appId]: [...state.thirdPartyApiKeys[appId], apiKey],
        }
      }

      return {
        ...state,
        [appId]: [apiKey],
      }
    }
    case `${GET_EXTERNAL_APIKEY}_FULFILLED`: {
      const { appId } = action.meta

      const apiKeys = action.payload.data.map(key => ({
        ...key,
        isValid: true,
      }))

      return {
        ...state,
        [appId]: apiKeys,
      }
    }
    case `${DELETE_EXTERNAL_APIKEY}_FULFILLED`: {
      const { appId, keyId: deletedKeyId } = action.meta

      const newThirdPartyApiKey = state[appId].filter(
        ({ id }) => id !== deletedKeyId
      )

      return {
        ...state,
        [appId]: newThirdPartyApiKey,
      }
    }
    case INVALIDATE_EXTERNAL_APIKEY: {
      const { appId, type: invalidApiKeyType } = action.meta

      const invalidApiKey = state[appId].find(
        ({ type }) => type === invalidApiKeyType
      )

      const validApiKeys = state[appId].filter(
        ({ type }) => type !== invalidApiKeyType
      )

      return {
        ...state,
        [appId]: [
          ...validApiKeys,
          {
            ...invalidApiKey,
            isValid: false,
          },
        ],
      }
    }

    default:
      return state
  }
}

// Actions
export const createThirdPartyApiKey = (appId, { type, key }) => ({
  type: SET_EXTERNAL_APIKEY,
  payload: generateRequestFor(`${appId}/api-keys`, POST, { type, key }),
  meta: { appId },
})

export const fetchThirdPartyApiKeys = appId => ({
  type: GET_EXTERNAL_APIKEY,
  payload: generateRequestFor(`${appId}/api-keys`, GET),
  meta: { appId },
})

export const deleteThirdPartyApiKey = (appId, keyId) => ({
  type: DELETE_EXTERNAL_APIKEY,
  payload: generateRequestFor(`${appId}/api-keys/${keyId}`, DELETE),
  meta: { appId, keyId },
})

export const updateThirdPartyApiKey = (appId, keyId, key) => ({
  type: UPDATE_EXTERNAL_APIKEY,
  payload: generateRequestFor(`${appId}/api-keys/${keyId}`, PUT, { key }),
  meta: { appId },
})

export const invalidateThirdPartyApiKey = (appId, type) => ({
  type: INVALIDATE_EXTERNAL_APIKEY,
  meta: { appId, type },
})

// Selectors
export const getThirdPartyApiKeys = (state, appId) =>
  state.thirdPartyApiKeys[appId]

export const getThirdPartyApiKeyFor = (state, appId, type) =>
  getThirdPartyApiKeys(state, appId)?.find(key => key.type === type)
